import React, { useState } from "react";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";

const ContactSection = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    linkedIn: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSending, setIsSending] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) {
      newErrors.firstName = true;
    }
    if (!formData.lastName.trim()) {
      newErrors.lastName = true;
    }
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email || !emailPattern.test(formData.email)) {
      newErrors.email = true;
    }
    if (!formData.message.trim()) {
      newErrors.message = true;
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length === 0) {
      setIsSending(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_SERVER_PUBLIC_URL}/sendEmail`,
          formData
        );
        if (response.status === 200) {
          console.log("Email sent successfully!");
          setIsModalVisible(true);
          setTimeout(() => {
            setIsModalVisible(false);
          }, 1000); // Display the modal for 1 second
        }
      } catch (error) {
        console.error("Error sending email:", error);
      }
      setIsSending(false);
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div
      id="contacts-section"
      className="w-screen min-h-screen relative flex items-center justify-center lg:justify-end p-4"
    >
      <div className="absolute text-white select-none font-bold text-[19vw] sm:text-[15vw] md:text-[15vw] lg:text-[18vw] left-4 bottom-0 leading-[15vw] opacity-5">
        LET'S <br />
        GET IN <br /> TOUCH
      </div>

      <div className="relative bg-[var(--darkGrey)] p-6 md:p-10 lg:p-16 shadow-xl w-full sm:w-[90vw] md:w-[70vw] lg:w-[40vw] lg:mr-[10vw]">
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex flex-col lg:flex-row lg:space-x-4">
            <div className="w-full lg:w-1/2 mb-4 lg:mb-0">
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="First Name"
                className={`w-full h-[50px] px-4 ${
                  errors.firstName ? "border-red-500 border-2" : ""
                } text-[var(--darkerGrey)]`}
              />
            </div>
            <div className="w-full lg:w-1/2">
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Last Name"
                className={`w-full h-[50px] px-4 ${
                  errors.lastName ? "border-red-500 border-2" : ""
                } text-[var(--darkerGrey)]`}
              />
            </div>
          </div>

          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email"
            className={`w-full h-[50px] px-4 ${
              errors.email ? "border-red-500 border-2" : ""
            } text-[var(--darkerGrey)]`}
          />

          <input
            type="text"
            name="linkedIn"
            value={formData.linkedIn}
            onChange={handleChange}
            placeholder="LinkedIn"
            className="w-full h-[50px] px-4 text-[var(--darkerGrey)]"
          />

          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Message"
            className={`w-full p-4 h-[120px] md:h-[150px] ${
              errors.message ? "border-red-500 border-2" : ""
            } text-[var(--darkerGrey)]`}
          ></textarea>

          <button
            type="submit"
            className={`${
              isSending ? "opacity-50" : "opacity-100"
            } bg-[var(--darkerGrey)] w-full text-white p-4 font-bold`}
            disabled={isSending}
          >
            Send Request
          </button>
        </form>
      </div>

      <AnimatePresence>
        {isModalVisible && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.5 }}
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50"
          >
            <div className="bg-white text-black p-6 rounded-lg shadow-lg text-center">
              Email Sent Successfully!
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ContactSection;
